import { useEffect, useState } from 'react';
import { Link, useNavigate, useParams, useSearchParams } from 'react-router-dom';
import { PagedResultState } from '../../common/CommonResult';
import { API } from '../../api';
import { Divider, Layout, notification, Space, Table } from 'antd';
import { title } from 'process';
const columns = [
  {
    title: 'баркод',
    dataIndex: 'trackingNumber',
    render: (row: any, data: any) => row,
    key: 'trackingNumber',
  },
  {
    title: 'Хүлээн авагч',
    render: (data: any) => (
      <span>
        {data.receiverLastName} {data.receiverFirstName} - {data.receiverPhone}
      </span>
    ),
    key: 'trackingNumber',
  },
  {
    title: 'хаяг',
    render: (data: any) => (
      <span>
        {data.receiverProvince} - {data.receiverLocality} - {data.receiverAddress1}
      </span>
    ),
    key: 'trackingNumber',
  },
  {
    title: 'zipcode',
    dataIndex: 'receiverPostalCode',
  },
];
export const ForeignOrderPackageDetail = () => {
  const [result, changeResult] = useState<PagedResultState<any>>({ loading: true, result: {} });
  const { no } = useParams();
  const [searchParams] = useSearchParams();
  const navigate = useNavigate();

  const updateQueryParam = (key: any, value: any) => {
    const params = new URLSearchParams(searchParams);
    if (value) {
      params.set(key, value); // Add or update param
    } else {
      params.delete(key); // Remove if value is empty
    }
    navigate({ search: params.toString() }, { replace: true });
  };
  useEffect(() => {
    if (no) {
      fetchData(no, searchParams.get('page') ?? 1);
    }
  }, [no, searchParams]);
  const fetchData = async (id: any, page: any) => {
    try {
      changeResult({ loading: true, result: {} });
      const response: any = await API.get({ apiVersion: 'api' })(
        `/shipping/list?page=${page}&packageNo=${id}`
      );
      console.log('response', response);
      changeResult({ loading: false, result: response.result });
    } catch (e: any) {
      console.log('exception', e);
      notification.success({
        message: 'Системд алдаа гарлаа',
        description: 'sdfjslkfj',
        duration: 300,
        placement: 'topRight',
      });
      console.log('bolson sh dee');
      changeResult({ loading: false, error: true, result: {} });
    }
  };
  return (
    <Layout.Content style={{ margin: '24px 16px 0' }}>
      <h3>Гадаад захиалгын жагсаалт</h3>
      <Divider />
      <div className="search-area">
        <Space wrap>
          {/* <Select style={{ width: 250 }} placeholder="Харилцагч" allowClear>
            <Select.Option value="sample">Sample</Select.Option>
          </Select>
          <Select style={{ width: 250 }} placeholder="Төлөв" allowClear>
            <Select.Option value="sample1">Үүссэн</Select.Option>
            
            <Select.Option value="sample3">Хүлээн авсан</Select.Option>
          </Select> */}
        </Space>
        <Table
          pagination={{
            onChange: (page) => updateQueryParam('page', page),
            pageSize: result.result.size ?? 10,
            total: result.result.total ?? 0,
            current: result.result.page,
          }}
          loading={result.loading}
          dataSource={result.result.data}
          columns={columns}
        />
      </div>
    </Layout.Content>
  );
};
